// JsFromRoutes CacheKey b93933e365dac59cdff99eda43d4b3f0
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from 'utils/js_from_routes_client'

export default {
  createAdministrator: /* #__PURE__ */ definePathHelper('get', '/employers/settings/create_administrator'),
  createAdministratorComplete: /* #__PURE__ */ definePathHelper('post', '/employers/settings/create_administrator'),
  destroyAdministrator: /* #__PURE__ */ definePathHelper('delete', '/employers/settings/destroy_administrator'),
  disconnectPayroll: /* #__PURE__ */ definePathHelper('post', '/employers/settings/disconnect_payroll'),
  payrollRedirect: /* #__PURE__ */ definePathHelper('get', '/employers/settings/payroll_redirect'),
  payrollComplete: /* #__PURE__ */ definePathHelper('get', '/employers/settings/payroll_complete'),
  show: /* #__PURE__ */ definePathHelper('get', '/employers/settings'),
  update: /* #__PURE__ */ definePathHelper('patch', '/employers/settings'),
}
